import { render } from "./notificationsView.vue?vue&type=template&id=789b52c4"
import script from "./notificationsView.vue?vue&type=script&lang=js"
export * from "./notificationsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__